<div class="op-wp-embedded-graph work-packages-embedded-view--container loading-indicator--location" #graphContainer [ngStyle]="{height: chartHeight}">
  @if (hasDataToDisplay) {
    <canvas baseChart
      [datasets]="chartData"
      [labels]="chartLabels"
      [type]="mappedChartType"
      [options]="internalChartOptions"
      >
      {{chartDescription}}
    </canvas>
  }
  @if (!hasDataToDisplay && initialized) {
    <op-no-results [title]="text.noResults" />
  }
</div>
